export const state = () => ({
  loading: false,
  pwa: {}
})

export const actions = {
  async getBannerPWA({ commit }, id) {
    try {
      const baseURL = `https://redirect.${this.$config.DOMAIN}`
      const response = await this.$axios.get(`${baseURL}/px/banners/settings/${id}`)
      this.$cookie.set('wl_locale', response?.data?.pwa_app_settings?.language)
      commit('setPWA', response.data)
      return true
    } catch (error) {
      return false
    }
  }
}

export const mutations = {
  setPWA(state, data) {
    state.pwa = data
  }
}
